import { apiHelper } from "@/utils";
import { API } from "@/constants";
const API_URL = `${API.BASE_URL_API}/v1`;
export const dashboardService = {
  getNewReports(page = 1, size = 15) {
    return apiHelper(API_URL).get("/dashboard/new-reports", {
      params: { page, size },
    });
  },
  getUpcomingEvents(page = 1, size = 15) {
    return apiHelper(API_URL).get("/dashboard/upcoming-events", {
      params: { page, size },
    });
  },
  getPendingArticles(page = 1, size = 15) {
    return apiHelper(API_URL).get("/dashboard/pending-articles", {
      params: { page, size },
    });
  },
  getCandidateCount() {
    return apiHelper(API_URL).get("/dashboard/candidates/current-month/count");
  },
  getLockedAppUsers(page = 1, size = 15) {
    return apiHelper(API_URL).get("/dashboard/locked-app-users", {
      params: { page, size },
    });
  },
  getLockedPortalUsers(page = 1, size = 15) {
    return apiHelper(API_URL).get("/dashboard/locked-portal-users", {
      params: { page, size },
    });
  },
  getPendingAppUsers(page = 1, size = 15) {
    return apiHelper(API_URL).get("/dashboard/pending-app-users", {
      params: { page, size },
    });
  },
};
